module.exports = __webpack_public_path__ + "img/placeholder-3-4.72b76893.png";